<div class="popup">
  <nb-card>
    <nb-card-header>
      <div class="title">Скачать прайс-лист</div>
    </nb-card-header>
    <nb-card-body>
      @if (queuIsEmpty == true) {
        <form aria-labelledby="title" [formGroup]="inputForm" (ngSubmit)="onSubmit()">
          <p>
            <nb-select formControlName="contract" i18n-placeholder="@@Contract" placeholder="Контракт" size="small" required fullWidth>
              @for (contract of contracts$ | async; track contract) {
                <nb-option [value]="contract.id">{{ contract.header }}</nb-option>
              }
            </nb-select>
          </p>
          <p>
            <nb-checkbox formControlName="availableProductSelect" [checked]="false">В наличии</nb-checkbox>
          </p>
          <!--        <p>-->
          <!--          <nb-checkbox formControlName="addPictureProducts" [checked]="false">Выгружать фото товаров</nb-checkbox>-->
        <!--        </p>-->
        <app-compo-tree [treeData]="data1">
          <ng-template let-item>
            <div class="export-excel-tree-box-item" [ngClass]="item.id==catalogId?'tree-node-selected':''">
              <div class="export-excel-tree-checkbox">
                <nb-checkbox [checked]="catalogCheckedIds.indexOf(item.id) > -1" (checkedChange)="categoryChecked(item.id, $event)"/>
                </div>
                <div class="export-excel-tree-header" (click)="setId(item.id); $event.preventDefault();" title="{{ item.header }}">
                  <a href="#"> {{ item.header }}
                    @if (!item.lastLevel) {
                      <tui-icon [icon]="item.expanded ? 'chevron-up':'chevron-down'"/>
                    }
                  </a>
                </div>
              </div>
            </ng-template>
          </app-compo-tree>
          <nb-card-footer>
            <button nbButton type="submit" size="large" status="primary" [nbSpinner]="submitted" nbSpinnerStatus="control" [disabled]="(!inputForm.valid || catalogCheckedIds.length == 0) || submitted">
              Сформировать
            </button>
            <button nbButton size="large" i18n="@@AddProduct" (click)="close()">
            Закрыть
          </button>
          </nb-card-footer>
        </form>
      }
      @if (queuIsEmpty == false) {
        <div>
          <p> В настоящий момент ваш запрос на генерацию прайс листа обрабатывается. </p>
          <p> Пожалуйста, дождитесь получения прайс-листа на вашу почту, прежде чем запрашивать новый. </p>
        </div>
      }
    </nb-card-body>
  </nb-card>
</div>
